import dayjs from 'dayjs';

// export const getNumberOfWeeksBetweenTwoDates = (startDate, endDate) => {
//   const msInWeek = 1000 * 60 * 60 * 24 * 7;

//   return Math.round(Math.abs(endDate - startDate) / msInWeek);
// };

export const getDatesWithinDateRange = (dateStart, dateEnd, selectedDays = []) => {
  let currentDate = dateStart,
    dates = [];
  
  while (currentDate <= dateEnd) {
    const dayName = dayjs(currentDate).format('ddd');
    
    // Add date only if no specific days are provided, or if it matches one of the selected days
    if (selectedDays.length === 0 || selectedDays.includes(dayName)) {
      dates.push(currentDate);
    }

    // Move to the next day
    let d = new Date(currentDate.valueOf());
    d.setDate(d.getDate() + 1);
    currentDate = d;
  }

  return formatDatesWithinDateRange(dates);
};


const formatDatesWithinDateRange = (selectedDateRange) => {
  const weekdaysOfDatesWithinRange = selectedDateRange.map((d) =>
    dayjs(d).format('ddd')
  );
  const datesOfDatesWithinRange = selectedDateRange.map((d) =>
    dayjs(d).format('YYYY-MM-DD')
  );
  return { weekdaysOfDatesWithinRange, datesOfDatesWithinRange };
};

// function filterWeekDays(dates, includeDays) {
//   var weekdays = [];

//   // cycle dates
//   dates.forEach(function (day) {
//     // cycle days to be included (so==0, mo==1, etc.)
//     includeDays.forEach(function (include) {
//       if (day.getDay() === include) {
//         weekdays.push(day);
//       }
//     });
//   });
//   return weekdays;
// }
